import React from "react";
import { Label, Input } from "reactstrap";

const DatePicker = ({
  value,
  onChange,
  label = "Date and Month",
  className = "",
}) => {
  return (
    <div className={`col-md-12 col-sm-12 ${className}`}>
      <Label>{label}</Label>
      <Input
        type="date"
        name="date"
        className="form-control digits uiStyleDashboard"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default DatePicker;
